<app-breadcrumb [title]="'Rastrear mi pedido'" [breadcrumb]="'Rastrear mi pedido'"></app-breadcrumb>
<div class="container">
    <ng-container *ngIf="orden && orden.orden">
        <div *ngFor="let ordenItem of orden.orden">
            <article class="card">
                <div class="card-body">
                    <h6>N° de Pedido:{{ordenItem.numeroOrden}}</h6>
                    <article class="card">
                        <div class="card-body row">
                            <div class="col"> <strong>Estatus:</strong>
                                <br>{{ordenItem.seguimiento[ordenItem.seguimiento.length - 1].evento.descripcion | titlecase}}
                            </div>
                            <div class="col"> <strong>Fecha estimada de entrega:</strong>
                                <br>{{ordenItem.entregaEstimada | date:'d \'de\' MMMM \'de\' y' | titlecase }}
                            </div>
                  
                            <div class="col" *ngIf="ordenItem.noGuia != null"> <strong>N° de Guía:</strong> <br>{{ordenItem.noGuia}} </div>

                 
                            <div class="col"  *ngIf="ordenItem.noGuia == null"> <strong>N° de Guía:</strong> <br>Pendiente</div>
                            

                            <div class="col"> <strong>Enviado por:</strong> <br>{{ordenItem.carrier}} </div>
                        </div>
                    </article>
                    <div class="track">
                        <!-- <div class="step" [ngClass]="{'cancel': ordenItem.seguimiento[0].evento.codigoEvento === 6}" *ngIf=" ordenItem.seguimiento[0].estatus === 6; else pendiente"> <span class="icon">
                                <i class="fa fa-ban"></i> </span> <span class="text">Orden Cancelada</span>
                            </div> -->
                        <!-- <div class="step active" [ngClass]="{'active': ordenItem.seguimiento[0].estatus < 6 && ordenItem.seguimiento[0].estatus > 1 }"> <span class="icon">
                                <i class="fa fa-clock-o"></i> </span> <span class="text">Orden Completada</span>
                            </div> -->
                        <div class="step active"> <span class="icon">
                                <i class="fa fa-clock-o"></i> </span> <span class="text">Orden Completada</span>
                        </div>
                        <div class="step"
                            [ngClass]="{'active': ['OK', 'PU', 'WC'].includes(this.arraySeguimiento[0].evento.codigoEvento)}">
                            <span class="icon"> <i class="fa fa-archive"></i> </span> <span
                                class="text">Recolectado</span>
                        </div>
                        <div class="step"
                            [ngClass]="{'active': [ 'WC'].includes(this.arraySeguimiento[0].evento.codigoEvento)}">
                            <span class="icon"> <i class="fa fa-truck"></i> </span> <span class="text">En camino</span>
                        </div>
                        <div class="step"   [ngClass]="{'active': ['WC','OK'].includes(this.arraySeguimiento[0].evento.codigoEvento)}">
                            <span class="icon"> <i class="fa fa-home"></i> </span> <span class="text">Entregado</span>
                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-around mx-2" style="border: 1px solid rgba(0, 0, 0, 0.1);">
                        <div class="col-md-8 col-12">
                            <div class="card-body my-2">
                                <h6>Detalles de seguimiento:</h6>
                                <div *ngFor="let seg of ordenItem.seguimiento">
                                    <!-- <div class="col"> <strong>Tiempo estimado de entrega: </strong>  {{ordenItem.fhregistro}}</div> -->
                                    <div class="col"> <strong><i class="fa fa-check" aria-hidden="true"></i>&nbsp;
                                            {{seg.fechaFormat}}:</strong>
                                        &nbsp;&nbsp; {{seg.evento.descripcion}}</div>
                                    <!-- <div class="col"> <strong>Estatus: </strong>   {{ordenItem.estatus}}</div> -->
                                    <!-- <div class="col"> <strong>N° de Guía: </strong> {{ordenItem.idOrden}}</div> -->
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-md-4 col-12 d-flex justify-content-center">
                            <div class="col-12 d-flex align-items-center flex-column justify-content-center my-3">
                                <h6 class="text-center font-italic">Agrega tus datos de facturación aquí haciendo clic
                                    en el siguiente botón. Asegúrate de proporcionar información precisa para generar
                                    tus facturas correctamente. </h6><br>
                                <span *ngIf="!disabledFact">Tienes hasta el <strong>último día del mes</strong> para
                                    generar tu factura</span>

                                <button class="btn-solid btn my-2" (click)="generarFact(orden.idOrden)">Agrega tus datos
                                    para facturar</button>
                            </div>
                        </div> -->
                    </div>
                </div>
            </article>
        </div>

    </ng-container>
    <div class="col-12 d-flex justify-content-center align-items-center center">
        <button class="btn-solid btn my-2" (click)="volver()">Volver</button>
    </div>
</div>


<!-- estatus
    fecha estiamda de entrega
numero de guia
enviado por 
estatus ubi paquete

 -->